export const trimmedValues = (data) => {
    const result = {};
    for (let key in data) {
        if (Object.hasOwn(data, key) && typeof data[key] === 'string') {
            result[key] = data[key].trim();
        } else {
            result[key] = data[key];
        }
    }
    return result;
}

export const trimmedArrayOfObjects = (array) => {
    return array.map(item => {
        const trimmedItem = {};
        for (const key in item) {
            if (typeof item[key] === 'string') {
                trimmedItem[key] = item[key].trim();
            } else {
                trimmedItem[key] = item[key];
            }
        }
        return trimmedItem;
    });
}